import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import {
  GeneratedContentCustomPromptInput,
  GeneratedContentCustomPromptPayload
} from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = GeneratedContentCustomPromptInput;
type TData = GeneratedContentCustomPromptPayload;

export const useContentGenerationAsk = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation generatedContentCustomPrompt($input: GeneratedContentCustomPromptInput!) {
      generatedContentCustomPrompt(input: $input) {
        success
        errors
        errorCode
        text
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
